import { Reveal } from "./Reveal";

export const Overline = ({ children, className = "" }) => (
  <span className={`inline-block font-mono text-xs font-semibold uppercase tracking-[0.28em] text-ff-ember ${className}`}>
    {children}
  </span>
);

/**
 * SectionHeading — left-aligned editorial header used across pages.
 */
export const SectionHeading = ({ overline, title, body, className = "", align = "left", ...props }) => (
  <Reveal className={`${align === "center" ? "mx-auto max-w-2xl text-center" : "max-w-3xl"} ${className}`} {...props}>
    {overline && <Overline>{overline}</Overline>}
    <h2 className="mt-4 font-display text-4xl font-bold leading-[1.05] tracking-tight text-ff-ivory md:text-5xl">
      {title}
    </h2>
    {body && <p className="mt-5 text-base leading-relaxed text-ff-grey md:text-lg">{body}</p>}
  </Reveal>
);

export default SectionHeading;
